module.exports = __webpack_public_path__ + "img/speaker-1.b52d2b9d.jpg";